import { OrgChartQuery } from '../../../__generated__/graphql';
import { OrgChartEmployee } from '../../OrgChart/types';

export const mapEmployees = (
  employees: OrgChartQuery['orgChartEmployees'] | undefined,
): OrgChartEmployee[] => {
  if (!employees) return [];

  return employees.map((e) => ({
    id: e.Id,
    name: e.Name,
    position: e.flair__Position__c ?? '',
    department: e.department?.Name ?? '',
    location: e.location?.Name ?? '-',
    companyEmail: e.flair__Company_Email__c ?? '-',
    phone: e.flair__Company_Phone_Number__c ?? '-',
    manager: e.manager
      ? {
          id: e.manager.Id,
          name: e.manager.Name,
        }
      : null,
    noOfSubEmployees: employees.filter((emp) => emp.flair__Manager__c === e.Id)
      .length,
    isCollapsed: false,
    avatarUrl: e.avatar?.url ?? '',
    departmentRef: e.department
      ? {
          id: e.department.Id,
          name: e.department.Name,
          active: e.department.flair__Active__c,
        }
      : null,
    locationRef: e.location
      ? {
          id: e.location.Id,
          name: e.location.Name,
          active: e.location.flair__Active__c,
        }
      : null,
    teams: (e.teams ?? []).map((t) => ({ id: t.Id, name: t.Name })),
  }));
};
